import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';

export function YouTubeDiscoveryNotice({ allowedPlatforms, className }: { allowedPlatforms?: string[] | null; className?: string }) {
  const { t } = useTranslation();
  if (allowedPlatforms?.length && !allowedPlatforms.includes('youtube')) return null;
  return <p className={cn("flex items-start gap-2 rounded-lg border border-border bg-muted/20 p-3 text-xs leading-relaxed text-muted-foreground", className)}>
    <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
    <span>{t('campaign.socialImport.youtubeDiscoveryNotice')}</span>
  </p>;
}
